import config from '../../config';
import typeOf from '../../helpers/typeOf';

const fnParam = key => {
    key = typeOf.isNumeric(key) ? `param${key + 1}` : key;

    return {
        keyTitle: key,
        visible: false
    };
};

const metaParams = [
    ...config.metaUtmParams.map(fnParam),
    ...Array.from(Array(config.metaParamsCount).keys()).map(fnParam),
];

// Config Data Table Headers
const configDataTable = {
    headers: {
        conversions: [
            {keyTitle: 'id', visible: true},
            {keyTitle: 'createdAt', visible: true},
            {keyTitle: 'updatedAt', visible: false},
            {keyTitle: 'status', visible: true},
            {keyTitle: 'timeFromTrackToAction', visible: false},
            {keyTitle: 'publisher', visible: true},
            {keyTitle: 'advCid', visible: false},
            {keyTitle: 'goalTitle', visible: false},
            {keyTitle: 'goalActions', visible: true},
            {keyTitle: 'typeAction', visible: false},
            {keyTitle: 'saleSum', visible: true},
            {keyTitle: 'publisherCreditPerLead', visible: true},
            {keyTitle: 'createdAtTrack', visible: false},
            {keyTitle: 'ip', visible: false},
            ...metaParams,
            {keyTitle: 'actions', visible: true, disabled: true},
        ],
        financeOperations: [
            {keyTitle: 'AdvertiserName', visible: true},
            {keyTitle: 'AdvertiserSite', visible: true},
            {keyTitle: 'Period', visible: true},
            {keyTitle: 'PublisherId', visible: true},
            {keyTitle: 'PublisherName', visible: true},
            {keyTitle: 'FTDsCount', visible: true},
            {keyTitle: 'CommissionRS', visible: true},
            {keyTitle: 'CommissionCPA', visible: true},
            {keyTitle: 'CommissionTotal', visible: true},
            {keyTitle: 'PaidTotal', visible: true},
            {keyTitle: 'BalanceEndDebt', visible: true},
            {keyTitle: 'BalanceEndHold', visible: true}
        ],
        postbackHistory: [
            {keyTitle: 'id', visible: true},
            {keyTitle: 'conversionPostback', visible: true},
            {keyTitle: 'createdAt', visible: true},
            {keyTitle: 'updatedAt', visible: true},
            {keyTitle: 'status', visible: true},
            {keyTitle: 'locale', keyHint: 'localePostback', visible: true},
            {keyTitle: 'currency', keyHint: 'currencyPostback', visible: true},
            {keyTitle: 'goalTitle', visible: false},
            {keyTitle: 'goalActions', visible: true},
            {keyTitle: 'conversionID', visible: true},
            {keyTitle: 'createdAtConversion', visible: false},
            {keyTitle: 'updatedAtConversion', visible: false},
            {keyTitle: 'conversionStatus', visible: true},
            {keyTitle: 'timeFromTrackToAction', visible: false},
            {keyTitle: 'advCid', visible: false},
            {keyTitle: 'typeAction', visible: false},
            {keyTitle: 'saleSum', visible: false},
            {keyTitle: 'publisherCreditPerLead', visible: false},
            {keyTitle: 'publisherCreditPerSale', visible: false},
            {keyTitle: 'createdAtTrack', visible: false},
            {keyTitle: 'ip', visible: false},
            ...metaParams,
            {keyTitle: 'sendAttempts', visible: true, disabled: true},
        ]
    }
};

export default configDataTable;
